module.exports = __webpack_public_path__ + "img/12.79d01fc6.svg";